module.exports = __webpack_public_path__ + "img/logo.a6989628.png";